

import React, { useContext } from 'react'
import { SkyInformationPopover } from './SkyPopover';
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService';
import { InsurancePurchaseContextStore, INSURANCE_CONTEXT_ACTIONS } from '../../../context/InsuracePurchaseContext'
import { PolicyHullExtensionContextStore, ACTIONS } from '../../../context/PolicyHullExtensionContext';
import { useLocation, useParams } from 'react-router-dom';
import { InsuranceBillingPeriod } from '../../../models/insurance-models/InsuranceBillingPeriodModel';
var classNames = require('classnames')

export const PersonalInjuryPopover = (props) => {
  const location = useLocation()
  const insurancePurchaseContext = useContext(InsurancePurchaseContextStore)
  
  return (
      <SkyInformationPopover eventId={'personal-injury-coverage'}>     
            <div className="text-small"> - Pays for damages for personal and advertising injury for which the insured is legally liable, including injury caused by the publication of material that is private (invasion of privacy), libelous or slanderous.</div>
            <div className="text-small"> - Standard SkyWatch.AI policies include {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}25,000 in personal and advertising injury expenses. You can increase this coverage for an additional premium</div>
            
        </SkyInformationPopover>
  );
}